export enum TypeLocationEnum {
  concrete = 0,
  raisedConcrete = 1,
  dirt = 2,
}
